import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { ProjectService } from '../../../services/project.service';
import { MatIconModule } from '@angular/material/icon';
import { ApiService } from '../../../services/api.service';
import { ViewModelMapperService } from '../../../services/view-model.mapper.service';
import { IconComponent } from '../../../ui-component-library/core/icon.component/icon.component';
import { vm_icon } from '../../../models/view-models/dm_icon.model';
import { dm_status } from '../../../models/data-models/dm_status.model';
import { ComponentType } from '../../../models/core-models/enums';

@Component({
  selector: 'app-status',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MatButtonModule,
    MatIconModule,
    IconComponent,
  ],
  templateUrl: './status.component.html',
  styleUrl: './status.component.css',
})
export class StatusComponent implements OnInit {
  private fb = inject(FormBuilder);

  projectstatus: dm_status[] = [];
  icons: vm_icon[] = [];
  statusForm: FormGroup;
  isEditMode = false;

  constructor(
    private apiService: ApiService,
    private viewModelMapper: ViewModelMapperService,
    private projectSrvc: ProjectService
  ) {
    this.apiService.dataChangeEvent$.subscribe((data) => {
      if (data.dataLoaded) {
        this.loadInitialData();
      }
    });
  }

  ngOnInit() {
    this.loadInitialData();
  }

  loadInitialData() {
    const projectComponentId =
      this.apiService.appComponent.find(
        (comp) => comp?.appComponentTitle?.toLowerCase() === ComponentType[ComponentType.Projects].toLowerCase()
      )?.id ?? '';
    this.projectstatus = this.viewModelMapper.mapAppStatusToComponent(projectComponentId, this.apiService.statuses);
    this.icons = this.viewModelMapper.getIconBasedOnControl(
      this.apiService.icons,
      this.apiService.iconControls,
      this.apiService.appComponent,
      'Projects'
    );
    this.createForm();
    this.loadExistingData();
  }

  createForm() {
    this.statusForm = this.fb.group({
      projectStatus: [null, Validators.required],
      projectIcon: [null, Validators.required],
    });
  }

  getFullData() {
    const selectedStatus = this.projectstatus.find((s) => s.id === this.statusForm.value.projectStatus);
    const selectedIcon = this.icons.find((i) => i.id === this.statusForm.value.projectIcon);
    return {
      ...this.statusForm.value,
      projectStatus: selectedStatus,
      projectIcon: selectedIcon,
    };
  }

  loadDataForEdit(): void {
    this.isEditMode = true;
    // this.loadExistingData();
  }

  private loadExistingData(): void {
    const existingData = this.projectSrvc.getProjectFormData().status;
    if (existingData?.projectStatus?.id && this.statusForm) {
      // Edit mode: use existing values
      this.statusForm.patchValue({
        projectStatus: existingData.projectStatus.id,
        projectIcon: existingData?.projectIcon?.id || null,
      });
    } else if (this.statusForm) {
      // Create mode: set default status to 'New'
      const defaultStatus = this.projectstatus.find((ps) => ps.appStatusTitle?.toLowerCase() === 'new');
      if (defaultStatus) {
        this.statusForm.patchValue({
          projectStatus: defaultStatus.id,
        });
      }
    }
  }
}
